import styled, { css } from 'styled-components';

// export const Container = styled.div`
//     height: 100vh;
//     ${props => props.$backgroundType === 'IMAGE' ? css`
//             background-image: ${props?.$backgroundImageUrl ? `url(${props?.$backgroundImageUrl})` : ''};
//             background-repeat: no-repeat;    
//             background-size:cover;
//         `
//         :
//         css`
//             background: ${props.$backgroundColorHex};
//         `
//     }
//     overflow-y:auto;
//     position:relative;

//     &::-webkit-scrollbar {
//         width: 5px;
//     }

//     &::-webkit-scrollbar-thumb {
//         background-color: #b0b0b0;
//         border-radius: 10px;
//     }
//     &::-webkit-scrollbar-track {
//         background-color: #f0f0f0;
//     }

//     @media all and (max-width:768px){
//         &::-webkit-scrollbar {
//             width: 0px;
//         }
//     }
// `;

export const Container = styled.div`
    height: auto;
    min-height: 100vh;
    overflow: hidden;
    
    ${props => props.$backgroundType === 'IMAGE' ? css`
            background-image: ${props?.$backgroundImageUrl ? `url(${props?.$backgroundImageUrl})` : ''};
            background-repeat: no-repeat;    
            background-size:cover;
        `
        :
        css`
            background: ${props.$backgroundColorHex};
        `
    }

    
    position:relative;
    /* overflow-y:auto;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #b0b0b0;
        border-radius: 10px;
    }
    &::-webkit-scrollbar-track {
        background-color: #f0f0f0;
    }

    @media all and (max-width:768px){
        &::-webkit-scrollbar {
            width: 0px;
        }
    } */
`;

export const Wrapper = styled.div`
    padding: 0 0 10vh 0;
    padding-bottom: 100px;
`;

export const HeaderWrapper = styled.div`
    margin-top: 60px;
    width: 50vw;
    /* height: auto; */
    max-width: 200px;
    margin-left: auto;
    margin-right: auto;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .profileImageWrapper{
        width: 60%;
        margin-left: auto;
        margin-right: auto;
        border-radius: 100%;
        overflow: hidden;
    }

    .domainNameWrapper{
        text-align: center;
        font-weight: 800;
        font-size: 16px;
        word-wrap: break-word;
    }

    .descriptionWrapper{
        text-align: center;
        font-size: 12px;
        font-weight: 600;
        color: #606060;

        word-wrap: break-word;
        word-break: keep-all;
        white-space: pre-line;
    }
`;